import { useEffect, useState } from 'react';
import { Place } from '../../components/shared/LocationFinder/types';
import { useQuery } from '@tanstack/react-query';
import getPlaceDetailsByPlaceIdRequest from '../api/getPlaceDetailsByPlaceIdRequest';
import { useRegion } from '../providers/regionProvider';
import getOverlappingRegionRequest from '../api/getOverlappingRegionRequest';
import getLocationFromPlace from '../fns/getLocationFromPlace';
import getRegionDataRequest from '../api/getRegionDataRequest';
const useLocation = (onLocationChange?: (args?: any) => any) => {
  const { setUserLocationInfo, userLocationInfo, setRegion, region } =
    useRegion();
  const [selectedPlace, setSelectedPlace] = useState<Place | null>(null);

  const { data: placeDetails } = useQuery(
    ['lat-lng-from-place', selectedPlace],
    () => {
      if (selectedPlace?.place_id) {
        return getPlaceDetailsByPlaceIdRequest(selectedPlace.place_id);
      }

      return [];
    },
  );

  // This listens to the query that fetches Place Details and updates the
  // userLocationInfo value. It also triggers the onLocationChange input parameter
  useEffect(() => {
    if (placeDetails?.result) {
      const location = getLocationFromPlace(placeDetails);
      setUserLocationInfo(location);
      if (onLocationChange) {
        onLocationChange();
      }
    }
  }, [placeDetails]);


  // This listens to tthe coordinates value of the userLocation variable
  // and fetches the overlapping region. By default, it returns everywhere
  const { data: partnerRegion } = useQuery(
    ['partner-region', userLocationInfo?.location?.coordinates],
    () => {
      if (userLocationInfo?.location?.coordinates) {
        return getOverlappingRegionRequest(
          userLocationInfo.location.coordinates,
        );
      }
      return getRegionDataRequest('all');
    },
  );

  // This syncs the overlapping region with the regionProvider
  // so that region is set everywhere in the app
  useEffect(() => {
    if (partnerRegion && partnerRegion.name != region?.name) {
      setRegion(partnerRegion);
    }

  }, [partnerRegion]);

  return {
    selectedPlace,
    setSelectedPlace,
    placeDetails,
    partnerRegion,
  };
};

export default useLocation;
